import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../../Pages/Navbar/JobSeekerNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import Footer from '../../Footer/Footer';
import './ViewJobs.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';

function ViewJobs() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const userId = user.id || '';
  console.log("userId:", userId);
  const [jobs, setJobs] = useState([]);
  const [jobSeekers, setJobSeekers] = useState([]);
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAllPositions, setShowAllPositions] = useState(false);
  const [viewedJobs, setViewedJobs] = useState([]);

  // Message modal states
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  // const [messageContent, setMessageContent] = useState("I'm interested in this job opportunity");
  const [messageContent, setMessageContent] = useState("");
  const [messages, setMessages] = useState([]);
  const [canSendMessage, setCanSendMessage] = useState(true);

  // Guided Chat States
  const [chatStatus, setChatStatus] = useState({ stepCount: 0, isLocked: false, nextSenderIsCandidate: true });
  const [candidateSubPlan, setCandidateSubPlan] = useState('free');
  const [allowFreeCustomChat, setAllowFreeCustomChat] = useState(false);
  const [inputSalary, setInputSalary] = useState('');
  const [employerHasSub, setEmployerHasSub] = useState(false);

  // Share and WhatsApp modal states
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareContent, setShareContent] = useState('');
  const [shareUrl, setShareUrl] = useState('');

  // Daily call count states
  const [dailyCallCount, setDailyCallCount] = useState(0);
  const [lastResetDate, setLastResetDate] = useState('');

  const getOptimizedImageUrl = (photoPath) => {
    if (!photoPath) return null;
    return `${BaseUrl}${photoPath.replace(/\.(jpg|jpeg|png)$/i, '.webp')}`;
  };

  // Filter states
  const [activeFilters, setActiveFilters] = useState({
    location: [],
    position: '',
    startDate: '',
    jobType: '',
    contractStatus: [],
    postBy: '',
    language: [],
    skills: []
  });

  const initialFilters = {
    location: [],
    position: '',
    startDate: '',
    jobType: '',
    contractStatus: [],
    postBy: '',
    language: [],
    skills: []
  };

  // Toggle states for filter sections
  const [showLocation, setShowLocation] = useState(true);
  const [showPosition, setShowPosition] = useState(true);
  const [showStartDate, setShowStartDate] = useState(true);
  const [showJobType, setShowJobType] = useState(true);
  const [showContractStatus, setShowContractStatus] = useState(true);
  const [showPostBy, setShowPostBy] = useState(true);
  const [showLanguage, setShowLanguage] = useState(true);
  const [showSkills, setShowSkills] = useState(true);
  const [showFiltersMobile, setShowFiltersMobile] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // States for showing more items
  const [showAllLocations, setShowAllLocations] = useState(false);
  const [showAllJobTypes, setShowAllJobTypes] = useState(false);
  const [showAllContractStatuses, setShowAllContractStatuses] = useState(false);
  const [showAllLanguages, setShowAllLanguages] = useState(false);
  const [showAllSkills, setShowAllSkills] = useState(false);

  // Dummy profile images array for fallback
  const dummyProfileImages = [
    'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    'https://cdn-icons-png.flaticon.com/512/847/847969.png',
    'https://cdn-icons-png.flaticon.com/512/1077/1077114.png',
    'https://cdn-icons-png.flaticon.com/512/149/149071.png',
    'https://cdn-icons-png.flaticon.com/512/219/219969.png',
    'https://cdn-icons-png.flaticon.com/512/921/921071.png'
  ];

  // Function to get a dummy profile image based on job id or random
  const getDummyProfileImage = (job) => {
    if (job.id) {
      const index = job.id.toString().split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % dummyProfileImages.length;
      return dummyProfileImages[index];
    }
    return dummyProfileImages[0];
  };

  // Data for filters (same as your existing data)
  const jobLocations = [
    { id: 'united-arab-emirates', name: 'United Arab Emirates (UAE)', icon: 'https://cdn.helperplace.com/country/united-arab-emirates.svg' },
    { id: 'dubai', name: 'Dubai', icon: 'https://cdn.helperplace.com/country/united-arab-emirates.svg' },
    { id: 'saudi-arabia', name: 'Saudi Arabia', icon: 'https://cdn.helperplace.com/country/saudi-arabia.svg' },
    { id: 'qatar', name: 'Qatar', icon: 'https://cdn.helperplace.com/country/qatar.svg' },
    { id: 'kuwait', name: 'Kuwait', icon: 'https://cdn.helperplace.com/country/kuwait.svg' },
    { id: 'bahrain', name: 'Bahrain', icon: 'https://flagcdn.com/w40/bh.png' },
    { id: 'oman', name: 'Oman', icon: 'https://cdn.helperplace.com/country/oman.svg' },
    { id: 'singapore', name: 'Singapore', icon: 'https://cdn.helperplace.com/country/singapore.svg' },
    { id: 'malaysia', name: 'Malaysia', icon: 'https://cdn.helperplace.com/country/malaysia.svg' },
    { id: 'hong-kong', name: 'Hong Kong', icon: 'https://cdn.helperplace.com/country/hong-kong.svg' },
    { id: 'japan', name: 'Japan', icon: 'https://flagcdn.com/w40/jp.png' },
    { id: 'south-korea', name: 'South Korea', icon: 'https://flagcdn.com/w40/kr.png' },
    { id: 'taiwan', name: 'Taiwan', icon: 'https://cdn.helperplace.com/country/taiwan.svg' },
    { id: 'germany', name: 'Germany', icon: 'https://flagcdn.com/w40/de.png' },
    { id: 'netherlands', name: 'Netherlands', icon: 'https://flagcdn.com/w40/nl.png' },
    { id: 'united-kingdom', name: 'United Kingdom', icon: 'https://flagcdn.com/w40/gb.png' },
    { id: 'italy', name: 'Italy', icon: 'https://flagcdn.com/w40/it.png' },
    { id: 'spain', name: 'Spain', icon: 'https://flagcdn.com/w40/es.png' },
    { id: 'france', name: 'France', icon: 'https://flagcdn.com/w40/fr.png' },
    { id: 'poland', name: 'Poland', icon: 'https://flagcdn.com/w40/pl.png' },
    { id: 'portugal', name: 'Portugal', icon: 'https://flagcdn.com/w40/pt.png' },
    { id: 'romania', name: 'Romania', icon: 'https://flagcdn.com/w40/ro.png' },
    { id: 'hungary', name: 'Hungary', icon: 'https://flagcdn.com/w40/hu.png' },
    { id: 'canada', name: 'Canada', icon: 'https://flagcdn.com/w40/ca.png' },
    { id: 'united-states', name: 'United States', icon: 'https://flagcdn.com/w40/us.png' },
    { id: 'australia', name: 'Australia', icon: 'https://flagcdn.com/w40/au.png' },
    { id: 'new-zealand', name: 'New Zealand', icon: 'https://flagcdn.com/w40/nz.png' }
  ];


  const jobPositions = [
    { id: 'domestic-helper', name: 'Domestic Helper', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'nanny', name: 'Nanny', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'cook', name: 'Cook', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'driver', name: 'Driver', icon: 'https://cdn.helperplace.com/icons/driver.svg' },
    { id: 'maid', name: 'Maid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'nurse', name: 'Nurse', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'houseboy', name: 'Houseboy', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'tailor', name: 'Tailor', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'teacher', name: 'Teacher', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'trainer', name: 'Trainer', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'gardener', name: 'Gardener', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'butler', name: 'Butler', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'housekeeper', name: 'Housekeeper', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'laundry-worker', name: 'Laundry Worker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'personal-assistant', name: 'Personal Assistant', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'caregiver', name: 'Caregiver', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'elder-care-companion', name: 'Elder Care Companion', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'pet-sitter-dog-walker', name: 'Pet Sitter/Dog Walker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'house-manager', name: 'House Manager', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'cleaner', name: 'Cleaner', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'maintenance-worker-handyman', name: 'Maintenance Worker/Handyman', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'baby-sitter', name: 'Baby Sitter', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'tutor', name: 'Tutor', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
    { id: 'chauffeur', name: 'Chauffeur', icon: 'https://cdn.helperplace.com/icons/driver.svg' },
    { id: 'housemaid', name: 'Housemaid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'kitchen-staff', name: 'Kitchen Staff', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'dining-room-attendant', name: 'Dining Room Attendant', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'personal-chef', name: 'Personal Chef', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'event-coordinator', name: 'Event Coordinator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'household-administrator', name: 'Household Administrator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
    { id: 'domestic-assistant', name: 'Domestic Assistant', icon: 'https://cdn.helperplace.com/icons/maid.svg' }
  ];

  const jobTypes = [
    { id: 'full time', name: 'Full Time', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
    { id: 'part time', name: 'Part Time', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
    { id: 'temporary', name: 'Temporary', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
    { id: 'permanent', name: 'Permanent', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
    { id: 'internship', name: 'Internship', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
    { id: 'contractual', name: 'Contractual', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
    { id: 'freelancer', name: 'Freelancer', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
    { id: 'volunteer', name: 'Volunteer', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
    { id: 'fresher', name: 'Fresher', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
  ];

  const contractStatuses = [
    { id: 'any', name: 'Any' },
    { id: 'contract', name: 'Finshed Contract' },
    { id: 'terminated', name: 'Terminated' },
    { id: 'break contract', name: 'Break Contract' },
    { id: 'transfer', name: 'Transfer' },
    { id: 'Any overseas experience', name: 'Any Overseas Experience' },
    { id: 'resigned', name: 'Resigned' },
  ];

  const postByOptions = [
    { id: 'direct', name: 'Direct' },
    { id: 'agency', name: 'Agency' }
  ];

  const languages = [
    { id: 'english', name: 'English' },
    { id: 'cantonese', name: 'Cantonese' },
    { id: 'mandarin', name: 'Mandarin' },
    { id: 'arabic', name: 'Arabic' },
    { id: 'hindi', name: 'Hindi' },
    { id: 'tagalog', name: 'Tagalog' },
    { id: 'malayali', name: 'Malayali' },
    { id: 'tamil', name: 'Tamil' },
    { id: 'nepali', name: 'Nepali' },
    { id: 'srilankan', name: 'Srilankan' },
    { id: 'japanese', name: 'Japanese' },
    { id: 'russian', name: 'Russian' },
    { id: 'bangali', name: 'Bangladeshi' },
    { id: 'vietnamese', name: 'Vietnamese' },
    { id: 'combodian', name: 'Combodian' },
    { id: 'iranian', name: 'Iranian' },
    { id: 'korean', name: 'Korean' }
  ];

  const mainSkills = [
    { id: 'babycare', name: 'Baby Care' },
    { id: 'childcare', name: 'Child Care' },
    { id: 'teencare', name: 'Teen Care' },
    { id: 'elderly-care', name: 'Elderly Care' },
    { id: 'pet-care', name: 'Pet Care' },
    { id: 'tutoring', name: 'Tutoring' },
    { id: 'cooking', name: 'Cooking' },
    { id: 'house-keeping', name: 'House-Keeping' },
    { id: 'cleaning', name: 'Cleaning' },
    { id: 'marketing', name: 'Marketing' },
    { id: 'grocerias', name: 'Grocerias' }
  ];

  // Polling effect for open message modal
  useEffect(() => {
    let intervalId;
    if (showMessageModal && selectedJob && userId) {
      intervalId = setInterval(() => {
        fetchMessages(selectedJob.user_id, userId, selectedJob.id);
      }, 15000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [showMessageModal, selectedJob, userId]);

  // Fetch messages when message modal opens
  // Update the fetchMessages function to properly fetch all messages
  const fetchMessages = async (employerId, jobSeekerId, jobId) => {
    try {
      // Fetch all messages
      const response = await fetch(`${BaseUrl}/message/get-all`);
      if (!response.ok) {
        throw new Error('Failed to fetch messages');
      }
      const allMessages = await response.json();

      // Filter messages for this specific conversation
      const filteredMessages = allMessages.filter(msg => {
        // Message must be between this employer and job seeker
        const isBetweenParties =
          (msg.emp_id === parseInt(employerId) && msg.job_seeker_id === parseInt(jobSeekerId)) ||
          (msg.emp_id === parseInt(jobSeekerId) && msg.job_seeker_id === parseInt(employerId));

        // If jobId is provided, only show messages for this specific job
        if (jobId) {
          return isBetweenParties && msg.job_id === parseInt(jobId);
        }

        return isBetweenParties;
      });

      // Sort messages by date (oldest first)
      filteredMessages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      // Format messages to identify sender correctly
      const formattedMessages = filteredMessages.map(msg => {
        // If sender_id matches current user ID, it's from job seeker
        if (msg.sender_id === parseInt(userId)) {
          return {
            ...msg,
            sender: 'job_seeker',
            senderName: 'You'
          };
        }
        // If sender_id matches employer ID, it's from employer
        else if (msg.sender_id === parseInt(employerId)) {
          return {
            ...msg,
            sender: 'employer',
            senderName: selectedJob?.emp_name || selectedJob?.name || 'Employer'
          };
        }
        // Otherwise, it's from the other party
        else {
          const isFromEmployer = msg.sender_id === parseInt(employerId);
          return {
            ...msg,
            sender: isFromEmployer ? 'employer' : 'job_seeker',
            senderName: isFromEmployer
              ? (selectedJob?.emp_name || selectedJob?.name || 'Employer')
              : 'You'
          };
        }
      });

      setMessages(formattedMessages);

      // Check chat status to re-apply templates during polling/after send
      const statusRes = await fetch(`${BaseUrl}/message/conversation-status?job_id=${jobId}&job_seeker_id=${jobSeekerId}`);
      if (statusRes.ok) {
        const statusData = await statusRes.json();
        setChatStatus(statusData);

        // Re-apply guided templates if necessary
        const enforceGuided = candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub;
        if (enforceGuided) {
          if (statusData.isLocked) {
            // Don't set message content — keep field empty, popup handles it
            setCanSendMessage(false);
          } else if (!statusData.nextSenderIsCandidate) {
            // Don't reset messageContent here — user may be typing
            setCanSendMessage(false);
          } else {
            const wasCandidate = canSendMessage; // already true = no change needed
            setCanSendMessage(true);
            // Only re-generate the template message when the turn just switched to candidate
            // (prevents overwriting with a weaker profile on every poll tick)
            if (!wasCandidate) {
              setMessageContent(getGuidedCandidateMessage(statusData.stepCount, currentUserProfile, selectedJob, inputSalary));
            }
          }
        } else {
          // Free chat, just use basic history check
          checkIfCanSendMessage(formattedMessages);
        }
      } else {
        // Fallback if status fetch fails
        checkIfCanSendMessage(formattedMessages);
      }

    } catch (error) {
      console.error('Error fetching messages:', error);
      setMessages([]); // Set empty array on error
      setCanSendMessage(true); // Allow sending if no messages found
    }
  };

  // Check if user can send message based on conversation rules
  const checkIfCanSendMessage = (messageHistory) => {
    if (!messageHistory || messageHistory.length === 0) {
      // No messages yet - can send first message
      setCanSendMessage(true);
      return;
    }

    // Get the last message in the conversation
    const lastMessage = messageHistory[messageHistory.length - 1];

    if (lastMessage.sender === 'job_seeker') {
      // If last message was from job seeker, wait for employer response
      setCanSendMessage(false);
    } else {
      // If last message was from employer, job seeker can reply
      setCanSendMessage(true);
    }
  };

  // Daily call count management
  useEffect(() => {
    const checkAndResetDailyCounts = () => {
      const today = new Date().toDateString();

      // If it's a new day, reset the counts
      if (lastResetDate !== today) {
        setDailyCallCount(0);
        setLastResetDate(today);

        // Save to localStorage for persistence
        localStorage.setItem('jobSeekerLastResetDate', today);
        localStorage.setItem('jobSeekerDailyCallCount', '0');
      }
    };

    // Load counts from localStorage on component mount
    const savedLastResetDate = localStorage.getItem('jobSeekerLastResetDate');
    const savedCallCount = parseInt(localStorage.getItem('jobSeekerDailyCallCount') || '0');

    const today = new Date().toDateString();

    if (savedLastResetDate === today) {
      setDailyCallCount(savedCallCount);
    } else {
      setDailyCallCount(0);
    }
    setLastResetDate(today);

    // Check every minute if date has changed
    const interval = setInterval(checkAndResetDailyCounts, 60000);
    return () => clearInterval(interval);
  }, [lastResetDate]);

  // Fetch subscription & admin settings on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        if (user.id) {
          const planRes = await fetch(`${BaseUrl}/api/candidate/subscription/${user.id}`);
          if (planRes.ok) {
            const planData = await planRes.json();
            if (planData && planData.subscription && planData.subscription.plan_type) {
              setCandidateSubPlan(planData.subscription.plan_type.toLowerCase());
            }
          }
        }
        const adminRes = await fetch(`${BaseUrl}/api/admin/settings/allow_free_custom_chat`);
        if (adminRes.ok) {
          const adminData = await adminRes.json();
          setAllowFreeCustomChat(adminData.is_enabled === 1);
        }
      } catch (e) {
        console.error("Error fetching config:", e);
      }
    };
    fetchConfig();
  }, [userId]);

  // Check if employer has Gold subscription (from users table)
  const hasGoldSubscription = (job) => {
    const planName = job.user_subscription?.plan_name?.toLowerCase();
    return planName?.includes('gold');
  };

  // Check if employer has Silver subscription (from users table)
  const hasSilverSubscription = (job) => {
    const planName = job.user_subscription?.plan_name?.toLowerCase();
    return planName?.includes('silver');
  };

  // Only paid employer plans should unlock custom chat for free candidates.
  const isPaidEmployerPlan = (planName) => {
    const normalized = String(planName || '').toLowerCase().trim();
    return normalized !== '' && !normalized.includes('free');
  };

  // Get subscription badge info (updated to use user subscription)
  const getSubscriptionBadge = (job) => {
    if (hasGoldSubscription(job)) {
      return { type: 'gold', icon: 'bi-star-fill', color: 'warning', text: 'Gold' };
    } else if (hasSilverSubscription(job)) {
      return { type: 'silver', icon: 'bi-star-fill', color: 'secondary', text: 'Silver' };
    }
    return null;
  };

  // Get employee details by comparing user_id with job_seekers.user_id
  const getEmployeeDetails = (job) => {
    if (!jobSeekers.length || !job.user_id) return null;

    const employee = jobSeekers.find(seeker => String(seeker.user_id) === String(job.user_id));
    return employee || null;
  };

  // Get current user's complete profile from job_seekers table
  const getCurrentUserProfile = () => {
    if (!jobSeekers.length || !user.id) return null;

    const userProfile = jobSeekers.find(seeker => String(seeker.user_id) === String(user.id));
    return userProfile || null;
  };

  // Enhanced function to get display values with proper fallbacks
  const getDisplayValue = (value, fallback = 'N/A') => {
    if (value === null || value === undefined || value === '') return fallback;
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(', ') : fallback;
    }
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value.replace(/\\"/g, '"'));
        return Array.isArray(parsed) && parsed.length > 0 ? parsed.join(', ') : (value || fallback);
      } catch {
        return value || fallback;
      }
    }
    return value.toString() || fallback;
  };

  const getProfileCategoryDisplay = (profile) => getDisplayValue(
    profile?.category ||
    profile?.job_category ||
    profile?.domestic_worker_category ||
    profile?.worker_category ||
    profile?.candidate_category
  );

  const getProfilePositionDisplay = (profile) => getDisplayValue(
    profile?.job_position ||
    profile?.position ||
    profile?.job_title ||
    profile?.applied_position ||
    profile?.preferred_position
  );

  const getSafeString = (value, fallback = '') => {
    if (value === null || value === undefined) return fallback;
    const str = String(value).trim();
    return str || fallback;
  };

  const getPrimaryJobPosition = (profile, job) => {
    const profilePositions = safeParseArray(profile?.job_position);
    if (profilePositions.length > 0) return getSafeString(profilePositions[0], 'Job Role');
    return getSafeString(profile?.job_position || job?.job_title, 'Job Role');
  };

  const extractJobPositionOnly = (job, profile) => {
    // Always prefer candidate's own profile position — never use employer's job title
    const safeParseFirst = (val) => {
      if (!val) return null;
      if (Array.isArray(val)) return getSafeString(val[0], null);
      try {
        const parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return getSafeString(parsed[0], null);
      } catch (e) { /* not json */ }
      return getSafeString(val, null);
    };
    const fromProfile =
      safeParseFirst(profile?.job_position) ||
      getSafeString(profile?.position, null) ||
      getSafeString(profile?.applied_position, null) ||
      getSafeString(profile?.preferred_position, null);
    if (fromProfile) return fromProfile;
    // Only use job title if profile has absolutely nothing
    const title = getSafeString(job?.job_title, '');
    if (title) {
      const match = title.match(/looking\s+for\s+(?:a|an)?\s*(.+)$/i);
      if (match && match[1]) return getSafeString(match[1].replace(/[.]+$/, ''), 'Job Role');
      const dashMatch = title.match(/^([^-]+?)\s*-\s*.+$/);
      if (dashMatch && dashMatch[1]) return getSafeString(dashMatch[1].trim(), 'Job Role');
      return title;
    }
    return 'Job Role';
  };

  const getCandidateExperienceYears = (profile) => {
    // total_work_experience is set in PersonalInfo e.g. '3 years', 'Fresher', 'Above 15 years'
    const exp =
      profile?.total_work_experience ||
      profile?.experience_years ||
      profile?.work_experience ||
      profile?.years_of_experience ||
      profile?.total_experience ||
      profile?.total_years_experience ||
      profile?.years_experience ||
      profile?.dtr_years_of_experience_doctor;
    if (typeof exp === 'number') return `${exp} years`;
    return getSafeString(exp, null) || null; // return null if genuinely missing
  };

  const getGuidedCandidateMessage = (stepCount, profile, job, manualSalary = '') => {
    const firstName = getSafeString(profile?.first_name || user?.first_name, '');
    const lastName = getSafeString(profile?.last_name || user?.last_name, '');
    const candidateName = [firstName, lastName].filter(Boolean).join(' ') || 'Candidate';
    const nationality = getSafeString(profile?.nationality, 'my country');
    const experienceYears = getCandidateExperienceYears(profile);
    const jobTitle = extractJobPositionOnly(job, profile);
    const expectedAmount = getSafeString(manualSalary, '[amount]');

    if (stepCount === 0) {
      return `Hello, I am ${candidateName} from ${nationality}. I am interested in the job opportunities you have posted. Kindly review my profile and let me know if it is suitable for your position.`;
    }
    if (stepCount === 2) {
      return `Thank you for your response. I look forward to your feedback. Please let me know if you need any additional information.`;
    }
    if (stepCount === 4) {
      const exp = experienceYears || '[your experience]';
      return `Thank you for your response.\nI have ${exp} of experience as ${jobTitle}.\nMy expected salary is ${expectedAmount}.\nI am available for interview at your convenience.`;
    }
    if (stepCount === 6) {
      return `Please call me at your convenience. Thank you.`;
    }
    return '';
  };

  useEffect(() => {
    const enforceGuided = candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub;
    if (!enforceGuided || !selectedJob || !chatStatus.nextSenderIsCandidate || chatStatus.isLocked) return;
    const template = getGuidedCandidateMessage(chatStatus.stepCount, currentUserProfile, selectedJob, inputSalary);
    if (template && (!messageContent || chatStatus.stepCount !== 4)) {
      setMessageContent(template);
    }
  }, [inputSalary, chatStatus.stepCount, chatStatus.nextSenderIsCandidate, chatStatus.isLocked, selectedJob, candidateSubPlan, allowFreeCustomChat, employerHasSub]);

  // Call functionality
  const handleCallClick = (job, e) => {
    e.stopPropagation();

    // Check daily limit for calls
    if (dailyCallCount >= 5) {
      Swal.fire({
        icon: 'warning',
        title: 'Daily Limit Reached',
        text: 'You have reached your daily limit of 5 calls. Please try again tomorrow.',
      });
      return;
    }

    // Get employee details for phone number
    const employee = getEmployeeDetails(job);
    let phoneNumber = employee?.phone_number || job.phone_number || '9820867896';
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
    let finalNumber = cleanNumber;

    if (!cleanNumber.startsWith('+')) {
      if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
        finalNumber = '+' + cleanNumber;
      } else if (cleanNumber.length === 10) {
        finalNumber = '+91' + cleanNumber;
      } else {
        finalNumber = '+919820867896';
      }
    }

    // Increment call count
    const newCallCount = dailyCallCount + 1;
    setDailyCallCount(newCallCount);
    localStorage.setItem('jobSeekerDailyCallCount', newCallCount.toString());

    window.location.href = `tel:${finalNumber}`;
  };

  // Share functionality
  const handleShareClick = (job, e) => {
    e.stopPropagation();

    const jobTitle = job.job_title || 'Job Opportunity';
    const employerName = job.emp_name || job.name || 'Employer';
    const location = job.working_city || job.state_or_province || 'Various Locations';

    const shareText = `Check out this ${jobTitle} position in ${location} posted by ${employerName}. Find more job opportunities on Gulf Worker.`;
    const shareUrlVal = `${window.location.origin}/jobdetails/${job.id}`;
    const fullShareContent = `${shareText} ${shareUrlVal}`;

    if (navigator.share) {
      navigator.share({
        title: `${jobTitle} - ${employerName}`,
        text: shareText,
        url: shareUrlVal,
      })
        .catch((error) => console.log('Error sharing:', error));
    } else {
      setSelectedJob(job);
      setShareContent(fullShareContent);
      setShareUrl(shareUrlVal);
      setShowShareModal(true);
    }
  };

  const shareViaWhatsApp = (text) => {
    const encodedText = encodeURIComponent(text);
    window.open(`https://wa.me/?text=${encodedText}`, '_blank');
  };

  const shareViaFacebook = (url) => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  };

  const shareViaTwitter = (text) => {
    const encodedText = encodeURIComponent(text);
    window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
  };

  const shareViaLinkedIn = (url) => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      Swal.fire({
        icon: 'success',
        title: 'Copied!',
        text: 'Link copied to clipboard',
        timer: 1500,
        showConfirmButton: false
      });
    });
  };

  const handleWhatsAppClick = (job, e) => {
    e.stopPropagation();

    if (!hasGoldSubscription(job)) {
      Swal.fire({
        icon: 'warning',
        title: 'Gold Subscription Required',
        text: 'WhatsApp feature is available only for Gold plan employers',
      });
      return;
    }

    // Get current user's complete profile
    const userProfile = getCurrentUserProfile();
    const profileData = userProfile || user;

    // Get employee details for WhatsApp number
    const employee = getEmployeeDetails(job);
    let whatsappNumber = employee?.whatsapp_number || job.phone_number || '9820867896';
    const cleanNumber = whatsappNumber.replace(/\D/g, '');
    let finalNumber = cleanNumber;

    if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
      finalNumber = cleanNumber;
    } else if (cleanNumber.length === 10) {
      finalNumber = '91' + cleanNumber;
    } else if (cleanNumber.length < 10) {
      finalNumber = '919820867896';
    } else {
      finalNumber = cleanNumber;
    }

    const jobTitle = job.job_title || 'this job position';
    const profileLink = `${window.location.origin}/candidateview/${user.id}/${user.first_name}`;

    // Build WhatsApp message with candidate details
    let whatsappMessage = `From Candidate: Hi, I'm interested in the ${jobTitle} opportunity from Gulfworker.net website\n\n`;
    whatsappMessage += `My Profile Details:\n`;
    whatsappMessage += `Name: ${getDisplayValue(profileData.first_name)} ${getDisplayValue(profileData.last_name)}\n`;
    whatsappMessage += `View my full profile: ${profileLink}`;

    window.open(`https://wa.me/${finalNumber}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  const handleMessageClick = async (job, e) => {
    e.stopPropagation();
    setEmployerHasSub(false);

    // Check if user is logged in
    if (!user.id) {
      Swal.fire({
        title: 'Login Required',
        text: 'You need to login to send a message',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Login',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // You need to implement login modal opening here
          // For now, we'll just show a message
          Swal.fire({
            title: 'Please login first',
            text: 'Use the login option in the navbar',
            icon: 'info'
          });
        }
      });
      return;
    }

    // Check if user has a resume
    try {
      // Fetch job seekers data to check if current user has a resume
      const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker`);
      const resumeData = await resumeResponse.json();
      const userProfile = resumeData.find(seeker => String(seeker.user_id) === String(user.id));
      setCurrentUserProfile(userProfile || null); // Store profile in state for polling
      const userHasResume = !!userProfile;

      if (!userHasResume) {
        Swal.fire({
          title: 'Resume Required',
          html: `
          <div style="text-align: center;">
            <p>You need to update your resume before sending messages to employers</p>
            <div class="mt-4">
              <button 
                id="update-resume-btn" 
                class="btn btn-success btn-sm me-2" 
                style="border-radius: 5px; height: 32px;">
                Update Resume
              </button>
            </div>
          </div>
        `,
          icon: 'info',
          showConfirmButton: false,
          showCloseButton: true,
          didOpen: () => {
            // Attach click handler to Update Resume button
            document.getElementById('update-resume-btn').onclick = () => {
              Swal.close();
              navigate('/personalinfo'); // Navigate to resume update page
            };
          }
        });
        return;
      }

      // Proceed with message modal
      setSelectedJob(job);
      setShowMessageModal(true);
      await fetchMessages(job.user_id, userId, job.id);

      // Fetch chat status for guided flow
      let stepCount = 0;
      let nextSenderIsCandidate = true;
      let isLocked = false;
      try {
        const statusRes = await fetch(`${BaseUrl}/message/conversation-status?job_id=${job.id}&job_seeker_id=${userId}`);
        if (statusRes.ok) {
          const statusData = await statusRes.json();
          stepCount = statusData.stepCount;
          nextSenderIsCandidate = statusData.nextSenderIsCandidate;
          isLocked = statusData.isLocked;
          setChatStatus(statusData);
        }
      } catch (e) {
        console.error('Error fetching chat status:', e);
      }

      // Fetch employer/agency subscription
      let empHasSub = false;
      try {
        const isAgency = job.post_by && job.post_by.toLowerCase() === 'agency';
        const subApiRoute = isAgency ? `/api/agency/subscription/${job.user_id}` : `/api/employer/subscription/${job.user_id}`;

        const empSubRes = await fetch(`${BaseUrl}${subApiRoute}`);
        if (empSubRes.ok) {
          const empSubData = await empSubRes.json();
          const subscription = empSubData?.subscription || {};
          const status = String(subscription.status || '').toLowerCase();
          const planType = subscription.plan_type || subscription.plan_name || subscription.name || '';
          const hasPaidEmployerPlan = isPaidEmployerPlan(planType);
          empHasSub = status === 'active' && hasPaidEmployerPlan;
          if (!empHasSub) {
            // Fallback to mapped user plan data on the selected job.
            empHasSub = hasGoldSubscription(job) || hasSilverSubscription(job);
          }
          setEmployerHasSub(empHasSub);
        }
      } catch (e) {
        console.error('Error fetching job poster sub:', e);
      }

      // If user is not paid and admin didn't allow free chat -> apply guided templates
      const enforceGuided = candidateSubPlan === 'free' && !allowFreeCustomChat && !empHasSub;

      if (enforceGuided) {
        // Clear manual inputs
        setInputSalary('');

        if (isLocked) {
          // Don't set message content — keep field empty, popup handles it
          setCanSendMessage(false);
        } else if (!nextSenderIsCandidate) {
          setMessageContent("");
          setCanSendMessage(false);
        } else {
          setCanSendMessage(true);
          setMessageContent(getGuidedCandidateMessage(stepCount, userProfile, job));
        }
      } else {
        // Free chat logic
        const firstName = user.first_name || 'Candidate';
        const lastName = user.last_name || '';
        const nationality = userProfile?.nationality || 'my country';
        setMessageContent(`Hello, my name is ${firstName} ${lastName}. I am from ${nationality}. I am interested in this job opportunity.`);
      }

    } catch (error) {
      console.error('Error checking resume status:', error);
      const firstName = user.first_name || 'Candidate';
      setMessageContent(`Hello, my name is ${firstName}. I am interested in this job.`);
    }

  };

  const handleCloseMessageModal = () => {
    setShowMessageModal(false);
    setMessageContent(""); // Reset to empty string
    setSelectedJob(null);
    setMessages([]); // Clear messages when modal closes
    setCanSendMessage(true); // Reset to allow sending
    setEmployerHasSub(false); // Reset unlock state between chats
  };

  const handleContactClick = (type) => {
    if (!selectedJob) return;

    // If candidate is on free plan, block and show upgrade message
    if (candidateSubPlan === 'free') {
      Swal.fire({
        title: 'Upgrade Required',
        text: 'You need an active subscription plan to view employer contact details.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'View Plans',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/subscriptionplans');
        }
      });
      return;
    }

    // Since this is the JobSeeker view, we want the Employer's contact info.
    // The backend `mailRoutes.js` was updated to include emp_phone, emp_phone_code, etc. 
    // in the `conversations/jobseeker` results.
    // In this component, `messages` contains the chat thread. We can snag info from any message.
    const lastMsg = messages && messages.length > 0 ? messages[messages.length - 1] : null;

    // Fallback: If no messages yet, we might need to fetch from somewhere else,
    // but usually there's at least the welcome message or we fetch them on open.
    if (!lastMsg) {
      Swal.fire('Not Available', 'Contact details are not available for this conversation yet.', 'info');
      return;
    }

    if (type === 'call') {
      const phoneCode = lastMsg.emp_phone_code || '';
      const phone = lastMsg.emp_phone || '';
      if (!phone) {
        Swal.fire('Not Available', 'Employer has not provided a phone number.', 'info');
        return;
      }
      window.location.href = `tel:${phoneCode}${phone}`;

    } else if (type === 'whatsapp') {
      const waCode = lastMsg.emp_whatsapp_code || lastMsg.emp_phone_code || '';
      const waNum = lastMsg.emp_whatsapp || lastMsg.emp_phone || '';
      if (!waNum) {
        Swal.fire('Not Available', 'Employer has not provided a WhatsApp number.', 'info');
        return;
      }
      const fullNum = `${waCode}${waNum}`.replace(/\D/g, '');
      window.open(`https://wa.me/${fullNum}`, '_blank');
    }
  };

  // const handleMessageContentChange = (e) => {
  //   setMessageContent(e.target.value);
  // };

  // Replace the handleSendMessage function with this fixed version:

  const handleSendMessage = async () => {
    const candidateProfile = currentUserProfile || getCurrentUserProfile() || user;
    if (!candidateProfile?.verification_status || String(candidateProfile.verification_status).toLowerCase() !== 'verified') {
      Swal.fire({
        icon: 'warning',
        title: 'Account Not Verified',
        text: 'After admin approval only you can send messages for jobs. Please wait for your account to be verified.'
      });
      return;
    }

    const enforceGuided = candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub;

    if (enforceGuided && (!canSendMessage || !chatStatus.nextSenderIsCandidate)) {
      Swal.fire({
        html: `
          <div style="text-align:center;padding:10px 0">
            <div style="font-size:3rem;margin-bottom:12px">📱💬</div>
            <p style="font-size:1rem;font-weight:600;color:#333;line-height:1.5">
              Wait for the employer's reply, or take a subscription to chat,
              send a WhatsApp message, email, or call directly.
            </p>
          </div>`,
        showCancelButton: true,
        confirmButtonText: '<i class="bi bi-whatsapp"></i> Subscribe Now',
        cancelButtonText: '<i class="bi bi-chat-left-dots"></i> Wait for Reply',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        reverseButtons: false,
        showCloseButton: true,
        customClass: {
          popup: 'subscribe-intercept-popup'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/candidate-subscription';
        }
        // If dismissed (Wait for Reply), just close the popup and do nothing
      });
      return;
    }

    let finalMessage = messageContent;

    if (enforceGuided) {
      if (chatStatus.stepCount === 4 && !inputSalary.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Expected Salary Required',
          text: 'Please enter your expected salary amount before sending.'
        });
        return;
      }

      const guidedMessage = getGuidedCandidateMessage(chatStatus.stepCount, currentUserProfile, selectedJob, inputSalary);
      if (!guidedMessage) {
        Swal.fire({
          html: `
            <div style="text-align:center;padding:10px 0">
              <div style="font-size:3rem;margin-bottom:12px">📱💬</div>
              <p style="font-size:1rem;font-weight:600;color:#333;line-height:1.5">
                Wait for the employer's reply, or take a subscription to chat,
                send a WhatsApp message, email, or call directly.
              </p>
            </div>`,
          showCancelButton: true,
          confirmButtonText: '<i class="bi bi-whatsapp"></i> Subscribe Now',
          cancelButtonText: '<i class="bi bi-chat-left-dots"></i> Wait for Reply',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#6c757d',
          reverseButtons: false,
          showCloseButton: true,
        }).then((result) => {
          if (result.isConfirmed) { window.location.href = '/candidate-subscription'; }
        });
        return;
      }

      // Always use the server-regenerated guided message to avoid profile data mismatch
      finalMessage = guidedMessage;
    }

    if (!finalMessage || !finalMessage.trim() || !selectedJob) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please enter a message',
      });
      return;
    }

    try {
      Swal.fire({
        title: 'Sending message...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Get current user's complete profile from job_seekers table
      const userProfile = getCurrentUserProfile();

      // Use the most complete profile data available
      const profileData = currentUserProfile || userProfile || user;

      // Check employer subscription level
      const isGoldEmployer = hasGoldSubscription(selectedJob);
      const isSilverEmployer = hasSilverSubscription(selectedJob);

      // Create profile link
      const profileLink = `${window.location.origin}/candidateview/${user.id}/${user.first_name}`;

      // Build message - clean for chat, detailed for email
      const messageForChat = finalMessage;

      // Only add contact details for Gold employers
      if (isGoldEmployer) {
        // Add additional fields if needed
      }

      const storeResponse = await fetch(`${BaseUrl}/message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          emp_id: selectedJob.user_id,
          job_seeker_id: user.id,
          sender_id: userId,
          message: messageForChat,
          sender_type: 'job_seeker',
          job_seeker_profile: profileData,
          profile_link: profileLink,
          job_id: selectedJob.id,
          is_custom_chat: !(candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub)
        })
      });

      if (!storeResponse.ok) {
        const errorData = await storeResponse.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to store message');
      }

      // FIXED: Create properly formatted email content with HTML line breaks
      const parseToArray = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
          try {
            const parsed = JSON.parse(val.replace(/\\"/g, '"'));
            return Array.isArray(parsed) ? parsed : [parsed];
          } catch {
            return [val];
          }
        }
        return [val];
      };

      const getCountriesWorkedFromExperience = (profile) => {
        const expItems = parseToArray(profile?.experience);
        if (!expItems.length) return '';
        const countries = new Set();
        expItems.forEach((exp) => {
          if (!exp || typeof exp !== 'object') return;
          const possible = [
            exp.country,
            exp.work_country,
            exp.employer_country,
            exp.country_name,
            exp.country_experience,
            exp.previous_hospital_country
          ];
          possible.forEach((val) => {
            parseToArray(val).forEach((c) => {
              const trimmed = getSafeString(c, '');
              if (trimmed) countries.add(trimmed);
            });
          });
        });
        return countries.size ? Array.from(countries).join(', ') : '';
      };

      const firstName = getSafeString(profileData.first_name, '');
      const lastName = getSafeString(profileData.last_name, '');
      const candidateName = [firstName, lastName].filter(Boolean).join(' ')
        || getSafeString(profileData.full_name || profileData.name, 'N/A');
      const emailSubject = `Job Application - ${getSafeString(candidateName, 'Candidate')} is interested in the "${selectedJob.job_title}" position`;
      const categoryDisplayRaw = getProfileCategoryDisplay(profileData);
      const categoryDisplay = categoryDisplayRaw === 'N/A'
        ? getProfilePositionDisplay(profileData)
        : categoryDisplayRaw;
      const experienceFromProfile = getCandidateExperienceYears(profileData);
      const experienceFallback = parseToArray(profileData?.experience).length
        ? `${parseToArray(profileData.experience).length} previous roles`
        : null;
      const totalExperienceDisplay = getDisplayValue(experienceFromProfile || experienceFallback);
      const currentLocationDisplay = getDisplayValue(
        profileData.current_country ||
        profileData.current_location ||
        profileData.current_city ||
        profileData.city ||
        profileData.country
      );
      const previousExperienceDisplay = getDisplayValue(
        profileData.gulf_europe_experience ||
        profileData.overseas_experience ||
        profileData.driving_country_experience ||
        profileData.candidates_country_experience ||
        getCountriesWorkedFromExperience(profileData)
      );
      const expectedSalaryRaw =
        getSafeString(inputSalary, '') ||
        (profileData?.expected_monthly_salary_currency && profileData?.expected_monthly_salary
          ? `${profileData.expected_monthly_salary_currency} ${profileData.expected_monthly_salary}`
          : profileData?.expected_monthly_salary_usd
            ? `USD ${profileData.expected_monthly_salary_usd}`
            : profileData?.expected_monthly_salary_qar
              ? `QAR ${profileData.expected_monthly_salary_qar}`
              : profileData?.expected_monthly_salary_omr
                ? `OMR ${profileData.expected_monthly_salary_omr}`
                : profileData?.expected_monthly_salary);
      const expectedSalaryDisplay = getDisplayValue(expectedSalaryRaw);
      const availabilityRaw =
        profileData?.preferred_start_date === 'Immediate'
          ? 'Immediate'
          : (profileData?.preferred_start_date || profileData?.notice_period || profileData?.availability);
      const availabilityDisplay = getDisplayValue(availabilityRaw);
      const replyLink = `${window.location.origin}${selectedJob.posted_by?.toLowerCase() === 'agency' ? '/a-jobposting' : '/viewjobposting'}?email=${encodeURIComponent(selectedJob.email_id)}`;
      const messageHtml = getSafeString(finalMessage, '').replace(/\n/g, '<br/>');

      // Create HTML formatted email message styled like the provided reference
      const emailMessageHTML = `
      <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #2c3e50; background-color: #ffffff;">
        <div style="font-size: 18px; font-weight: 700; padding-bottom: 8px; border-bottom: 2px solid #2f86eb;">
          Job Application Interest
        </div>

        <div style="margin: 18px 0 16px 0; padding: 14px 16px; background-color: #f6f8fb; border-left: 4px solid #2f86eb;">
          <div style="font-weight: 700; margin-bottom: 6px;">Message:</div>
          <div style="margin-bottom: 10px; color: #3f4a56;">${messageHtml || 'N/A'}</div>
          <ul style="margin: 8px 0 0 18px; padding: 0; color: #334155;">
            <li><strong>Category:</strong> ${categoryDisplay}</li>
            <li><strong>Total Experience:</strong> ${totalExperienceDisplay}</li>
            <li><strong>Current Location:</strong> ${currentLocationDisplay}</li>
            <li><strong>Previous Gulf/Europe Experience:</strong> ${previousExperienceDisplay}</li>
            <li><strong>Expected Salary:</strong> ${expectedSalaryDisplay}</li>
            <li><strong>Notice Period / Availability:</strong> ${availabilityDisplay}</li>
          </ul>
        </div>

        <div style="font-size: 16px; font-weight: 700; margin: 18px 0 8px 0;">Profile Details:</div>
        <table style="width: 100%; border-collapse: collapse; margin: 8px 0 16px 0;">
          <tr>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; width: 160px; background-color: #f8fafc;">Name:</td>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${candidateName || 'N/A'}</td>
          </tr>
          <tr>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Category:</td>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${categoryDisplay}</td>
          </tr>
          <tr>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Experience:</td>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${totalExperienceDisplay}</td>
          </tr>
          <tr>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Current Location:</td>
            <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${currentLocationDisplay}</td>
          </tr>
        </table>

        <div style="margin: 6px 0 4px 0;">
          <a href="${profileLink}" style="display: inline-block; background-color: #2f86eb; color: #ffffff; text-decoration: none; padding: 9px 14px; border-radius: 6px; font-weight: 700; font-size: 13px; margin-right: 8px;">
            View Full Profile
          </a>
          <a href="${replyLink}" style="display: inline-block; background-color: #25a244; color: #ffffff; text-decoration: none; padding: 9px 14px; border-radius: 6px; font-weight: 700; font-size: 13px;">
            Reply Now
          </a>
          <div style="font-size: 11px; color: #6b7280; margin-top: 4px;">Quick Response Recommended</div>
        </div>

        <div style="margin-top: 16px; font-size: 12px; color: #7f8c8d;">
          This is an automated message from Gulf Worker job portal.
        </div>
      </div>
    `;

      // Alternative: Plain text version with proper line breaks
      const emailMessagePlainText =
        `I am Interested in the job details\n\n` +
        `1) Profile Details : ${getDisplayValue(profileData.first_name)} ${getDisplayValue(profileData.last_name)}\n\n` +
        `2) View Profile : ${profileLink}\n\n` +
        `3) View Job : ${window.location.origin}${selectedJob.posted_by?.toLowerCase() === 'agency' ? '/a-jobposting' : '/viewjobposting'}?email=${encodeURIComponent(selectedJob.email_id)}\n\n` +
        `---\n\n` +
        `Message from candidate:\n${messageContent}\n\n` +
        `Best regards,\n${getDisplayValue(profileData.first_name)} ${getDisplayValue(profileData.last_name)}`;

      // Send email with properly formatted content
      try {
        const emailResponse = await fetch(`${BaseUrl}/api/send-email`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            to_email: selectedJob.email_id,
            subject: emailSubject,
            message: emailMessageHTML,  // Use HTML version
            // If your API supports plain text, you can also send:
            // text_message: emailMessagePlainText
          })
        });

        if (!emailResponse.ok) {
          console.warn('Email sending failed, but message was stored');
        }
      } catch (emailError) {
        console.warn('Email sending failed:', emailError);
      }

      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Message sent successfully with your profile details!',
        timer: 2000,
        showConfirmButton: false
      }).then(() => {
        // Clear textarea so nothing shows while waiting for employer reply
        setMessageContent('');
        setInputSalary('');
        // Refresh messages to show the newly sent message and update canSendMessage status
        fetchMessages(selectedJob.user_id, userId, selectedJob.id);
      });

    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: error.message || 'An error occurred. Please try again.',
      });
    }
  };

  // Rest of your existing functions (toggleFilter, resetAllFilters, toggleRadioFilter, handleJobClick, formatDate, safeParseArray, getDisplayArray) remain the same...

  const toggleFilter = (filterType, id) => {
    setActiveFilters((prev) => {
      const currentValues = prev[filterType] || [];
      const newValues = currentValues.includes(id)
        ? currentValues.filter((item) => item !== id)
        : [...currentValues, id];
      return { ...prev, [filterType]: newValues };
    });
  };

  const resetAllFilters = () => {
    setActiveFilters(initialFilters);
    setShowAllLocations(false);
    setShowAllJobTypes(false);
    setShowAllContractStatuses(false);
    setShowAllLanguages(false);
    setShowAllSkills(false);
    setShowAllPositions(false);
  };

  const toggleRadioFilter = (filterType, id) => {
    setActiveFilters((prev) => ({
      ...prev,
      [filterType]: prev[filterType] === id ? '' : id
    }));
  };

  const handleJobClick = async (job) => {
    // First, track the job view
    try {
      const trackResponse = await fetch(`${BaseUrl}/api/track-job-view`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          job_id: job.id,
          employee_id: userId, // Current logged-in employee
          user_id: job.user_id // User who posted the job
        })
      });

      if (!trackResponse.ok) {
        console.warn('Failed to track job view, but continuing...');
      }
    } catch (error) {
      console.error('Error tracking job view:', error);
    }

    // Then update view count (your existing code)
    if (!viewedJobs.includes(job.id) && user.id) {
      try {
        const response = await fetch(`${BaseUrl}/api/employer?temporary_id=${job.id}&user_id=${user.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...job,
            view_count: job.view_count ? job.view_count + 1 : 1
          })
        });

        if (response.ok) {
          setJobs(prevJobs =>
            prevJobs.map(j =>
              j.id === job.id
                ? { ...j, view_count: j.view_count ? j.view_count + 1 : 1 }
                : j
            )
          );
          setFilteredJobs(prevJobs =>
            prevJobs.map(j =>
              j.id === job.id
                ? { ...j, view_count: j.view_count ? j.view_count + 1 : 1 }
                : j
            )
          );

          setViewedJobs(prev => [...prev, job.id]);
        }
      } catch (error) {
        console.error('Error updating view count:', error);
      }
    }

    navigate('/jobdetails', { state: { job } });
  };



  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      // Handle different date formats
      let date;

      if (dateString.includes('T')) {
        // ISO format with T (e.g., "2025-09-03T15:00:00.000Z")
        date = new Date(dateString);
      } else if (dateString.includes(' ')) {
        // Datetime format without T (e.g., "2025-09-03 15:00:00")
        // Replace space with T to convert to ISO-like format
        date = new Date(dateString.replace(' ', 'T'));
      } else {
        // Date only format (e.g., "2025-09-03")
        date = new Date(dateString + 'T00:00:00');
      }

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return 'N/A';
      }

      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch (e) {
      console.error('Error formatting date:', e);
      return 'N/A';
    }
  };

  const safeParseArray = (field) => {
    if (Array.isArray(field)) return field;
    if (typeof field === 'string') {
      try {
        const parsed = JSON.parse(field.replace(/\\"/g, '"'));
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  // Function to safely get array values for display
  const getDisplayArray = (field) => {
    if (!field) return 'N/A';
    if (Array.isArray(field)) {
      return field.length > 0 ? field.join(', ') : 'N/A';
    }
    if (typeof field === 'string') {
      try {
        const parsed = JSON.parse(field.replace(/\\"/g, '"'));
        return Array.isArray(parsed) && parsed.length > 0 ? parsed.join(', ') : 'N/A';
      } catch {
        return field || 'N/A';
      }
    }
    return 'N/A';
  };

  // Your existing useEffect hooks for data fetching and filtering remain the same...
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);

  //       // Fetch both employers, job seekers, and users data
  //       const [employersResponse, jobSeekersResponse, usersResponse] = await Promise.all([
  //         fetch(`${BaseUrl}/api/employer/all`),
  //         fetch(`${BaseUrl}/api/job-seekers`),
  //         fetch(`${BaseUrl}/`) // Users API endpoint
  //       ]);

  //       if (!employersResponse.ok) {
  //         throw new Error('Failed to fetch employers data');
  //       }
  //       if (!usersResponse.ok) {
  //         throw new Error('Failed to fetch users data');
  //       }

  //       let employersData = await employersResponse.json();
  //       const usersData = await usersResponse.json();
  //       let jobSeekersData = [];

  //       if (jobSeekersResponse.ok) {
  //         jobSeekersData = await jobSeekersResponse.json();
  //       } else {
  //         console.warn('Job seekers endpoint not available, using empty array');
  //       }

  //       // Create a map of users for easy lookup
  //       const usersMap = {};
  //       usersData.forEach(user => {
  //         usersMap[user.id] = user;
  //       });

  //       // Filter approved jobs and check subscription from users table
  //       const currentDate = new Date().toISOString().split('T')[0];
  //       employersData = employersData.filter(job => {
  //         // Check if job is approved
  //         if (job.status !== 'Approved') return false;

  //         // Find the corresponding user for this job
  //         const user = usersMap[job.user_id];
  //         if (!user) return false;

  //         // Check if user has valid subscription dates from users table
  //         const userPlanEndDate = user.plan_enddate;
  //         if (!userPlanEndDate) return false;

  //         return new Date(userPlanEndDate) >= new Date(currentDate);
  //       });

  //       // Priority mapping (lower number = higher priority)
  //       const priorityMap = {
  //         'gold': 1,
  //         'free posting': 1,
  //         'silver': 2
  //       };

  //       const normalizePlan = (planName = '') =>
  //         (planName || '').toString().trim().toLowerCase();

  //       const getJobTimestamp = (job) => {
  //         const candidates = [
  //           job.createdAt,
  //           job.created_at,
  //           job.job_posted_date,
  //           job.posted_at,
  //           job.createdOn,
  //           job.postedDate,
  //           job.posted_date
  //         ];

  //         for (const val of candidates) {
  //           if (!val) continue;
  //           const ts = new Date(val).getTime();
  //           if (!isNaN(ts)) return ts;
  //         }

  //         if (typeof job.created_timestamp === 'number' && !isNaN(job.created_timestamp)) {
  //           return job.created_timestamp;
  //         }

  //         if (job.plan_startdate) {
  //           const ts = new Date(job.plan_startdate).getTime();
  //           if (!isNaN(ts)) return ts;
  //         }

  //         return 0;
  //       };

  //       // Sort by plan priority first, then by posting date
  //       employersData.sort((a, b) => {
  //         const planA = normalizePlan(a.plan_name);
  //         const planB = normalizePlan(b.plan_name);

  //         const priorityA = priorityMap[planA] ?? (planA.includes('free') ? 1 : 3);
  //         const priorityB = priorityMap[planB] ?? (planB.includes('free') ? 1 : 3);

  //         if (priorityA !== priorityB) {
  //           return priorityA - priorityB;
  //         }

  //         const tsA = getJobTimestamp(a);
  //         const tsB = getJobTimestamp(b);

  //         return tsB - tsA;
  //       });

  //       // Safely parse stringified arrays and prepare profile photo URL
  //       // Safely parse stringified arrays and prepare profile photo URL
  //       employersData = employersData.map(job => ({
  //         ...job,
  //         preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
  //         candidates_country_experience: safeParseArray(job.candidates_country_experience),
  //         main_skills: safeParseArray(job.main_skills),
  //         cooking_skills: safeParseArray(job.cooking_skills),
  //         other_skills: safeParseArray(job.other_skills),
  //         preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
  //         offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates),
  //         preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
  //         profile_photo_url: job.profile_photo ? `${BaseUrl}${job.profile_photo}` : null,
  //         // Add dummy profile image for fallback
  //         dummy_profile_image: getDummyProfileImage(job),
  //         // Add user subscription info to job object for easy access
  //         user_subscription: usersMap[job.user_id] ? {
  //           plan_startdate: usersMap[job.user_id].plan_startdate,
  //           plan_enddate: usersMap[job.user_id].plan_enddate,
  //           plan_name: usersMap[job.user_id].plan_name
  //         } : null
  //       }));

  //       setJobs(employersData);
  //       setFilteredJobs(employersData);
  //       setJobSeekers(jobSeekersData);

  //       // Set current user profile if available
  //       if (jobSeekersData.length && user.id) {
  //         const userProfile = jobSeekersData.find(seeker => seeker.user_id === user.id);
  //         setCurrentUserProfile(userProfile);
  //       }

  //     } catch (err) {
  //       setError(err.message);
  //       console.error('Error fetching data:', err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [user.id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch both employers, job seekers, and users data
        const [employersResponse, jobSeekersResponse, usersResponse] = await Promise.all([
          fetch(`${BaseUrl}/api/employer/all`),
          fetch(`${BaseUrl}/api/job-seeker`),
          fetch(`${BaseUrl}/`) // Users API endpoint
        ]);

        if (!employersResponse.ok) {
          throw new Error('Failed to fetch employers data');
        }
        if (!usersResponse.ok) {
          throw new Error('Failed to fetch users data');
        }

        let employersData = await employersResponse.json();
        const usersData = await usersResponse.json();
        let jobSeekersData = [];

        if (jobSeekersResponse.ok) {
          jobSeekersData = await jobSeekersResponse.json();
        } else {
          console.warn('Job seekers endpoint not available, using empty array');
        }

        // Create a map of users for easy lookup
        const usersMap = {};
        usersData.forEach(user => {
          usersMap[user.id] = user;
        });

        // Filter only approved/active jobs
        employersData = employersData.filter(job => {
          const status = (job.status || '').toLowerCase().trim();
          return status === 'approved' || status === 'active';
        });

        // Get timestamp from posted_on column
        const getJobTimestamp = (job) => {
          // Check if posted_on exists and is valid
          if (job.posted_on) {
            const ts = new Date(job.posted_on).getTime();
            if (!isNaN(ts)) return ts;
          }

          // Fallback to other date fields if posted_on doesn't exist
          const candidates = [
            job.createdAt,
            job.created_at,
            job.job_posted_date,
            job.posted_at,
            job.createdOn,
            job.postedDate,
            job.posted_date
          ];

          for (const val of candidates) {
            if (!val) continue;
            const ts = new Date(val).getTime();
            if (!isNaN(ts)) return ts;
          }

          if (typeof job.created_timestamp === 'number' && !isNaN(job.created_timestamp)) {
            return job.created_timestamp;
          }

          if (job.plan_startdate) {
            const ts = new Date(job.plan_startdate).getTime();
            if (!isNaN(ts)) return ts;
          }

          return 0;
        };

        // Safely parse stringified arrays and prepare profile photo URL
        employersData = employersData.map(job => ({
          ...job,
          preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
          candidates_country_experience: safeParseArray(job.candidates_country_experience),
          main_skills: safeParseArray(job.main_skills),
          cooking_skills: safeParseArray(job.cooking_skills),
          other_skills: safeParseArray(job.other_skills),
          preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
          offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates),
          preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
          profile_photo_url: getOptimizedImageUrl(job.profile_photo),
          // Add dummy profile image for fallback
          dummy_profile_image: getDummyProfileImage(job),
          // Add user subscription info to job object for easy access
          user_subscription: usersMap[job.user_id] ? {
            plan_startdate: usersMap[job.user_id].plan_startdate,
            plan_enddate: usersMap[job.user_id].plan_enddate,
            plan_name: usersMap[job.user_id].plan_name
          } : null
        }));

        // Separate jobs by plan type
        const goldJobs = [];
        const silverJobs = [];
        const freeJobs = [];

        employersData.forEach(job => {
          if (hasGoldSubscription(job)) {
            goldJobs.push(job);
          } else if (hasSilverSubscription(job)) {
            silverJobs.push(job);
          } else {
            freeJobs.push(job);
          }
        });

        // Sort each category by posted_on timestamp (newest first)
        goldJobs.sort((a, b) => {
          const timestampA = getJobTimestamp(a);
          const timestampB = getJobTimestamp(b);
          return timestampB - timestampA; // Descending order (newest first)
        });

        silverJobs.sort((a, b) => {
          const timestampA = getJobTimestamp(a);
          const timestampB = getJobTimestamp(b);
          return timestampB - timestampA; // Descending order (newest first)
        });

        freeJobs.sort((a, b) => {
          const timestampA = getJobTimestamp(a);
          const timestampB = getJobTimestamp(b);
          return timestampB - timestampA; // Descending order (newest first)
        });

        // Combine in order: Gold first, then Silver, then Free
        const sortedJobs = [...goldJobs, ...silverJobs, ...freeJobs];

        console.log('Sorted Jobs:', sortedJobs.map(j => ({
          id: j.id,
          plan: j.user_subscription?.plan_name,
          posted_on: j.posted_on,
          timestamp: getJobTimestamp(j)
        })));

        setJobs(sortedJobs);
        setFilteredJobs(sortedJobs);
        setJobSeekers(jobSeekersData);

        // Set current user profile if available
        if (jobSeekersData.length && user.id) {
          const userProfile = jobSeekersData.find(seeker => String(seeker.user_id) === String(user.id));
          setCurrentUserProfile(userProfile);
        }

      } catch (err) {
        setError(err.message);
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.id]);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenWidth < 768;

  useEffect(() => {
    let result = [...jobs];

    if (activeFilters.position) {
      result = result.filter(job => {
        const category = job.domestic_worker_category?.toLowerCase();
        return (activeFilters.position === 'domestic-helper' && category?.includes('domestic helper')) ||
          (activeFilters.position === 'nanny' && category?.includes('nanny')) ||
          (activeFilters.position === 'cook' && category?.includes('cook')) ||
          (activeFilters.position === 'driver' && category?.includes('driver'));
      });
    }

    if (activeFilters.location.length > 0) {
      result = result.filter(job => {
        const preferredLocations = job.preferred_candidates_country?.map(loc => loc.toLowerCase()) || [];
        return activeFilters.location.some(locationId => {
          const location = jobLocations.find(loc => loc.id === locationId);
          if (!location) return false;

          return preferredLocations.includes(location.name.toLowerCase());
        });
      });
    }

    if (activeFilters.jobType) {
      const selectedType = activeFilters.jobType.toLowerCase().replace(/[-\s]/g, '');

      result = result.filter(job => {
        const type = job.job_type?.toLowerCase().replace(/[-\s]/g, '');
        return type?.includes(selectedType);
      });
    }

    if (activeFilters.contractStatus.length > 0) {
      result = result.filter(job => {
        const status = job.contract_status?.toLowerCase();
        return activeFilters.contractStatus.some(contractStatus =>
          status?.includes(contractStatus)
        );
      });
    }

    if (activeFilters.postBy) {
      result = result.filter(job => {
        const type = job.posted_by?.toLowerCase();
        return type?.includes(activeFilters.postBy.toLowerCase());
      });
    }

    if (activeFilters.language.length > 0) {
      result = result.filter(job => {
        const langs = job.preferred_language_for_worker?.join(' ').toLowerCase() || '';
        return activeFilters.language.some(lang => {
          const language = languages.find(l => l.id === lang);
          return language && langs.includes(language.name.toLowerCase());
        });
      });
    }

    if (activeFilters.skills.length > 0) {
      result = result.filter(job => {
        const skills = job.main_skills?.join(' ').toLowerCase() || '';
        return activeFilters.skills.some(skillId => {
          const skill = mainSkills.find(s => s.id === skillId);
          return skill && skills.includes(skill.name.toLowerCase());
        });
      });
    }

    if (activeFilters.startDate) {
      try {
        const selectedDate = new Date(activeFilters.startDate);
        selectedDate.setHours(0, 0, 0, 0);

        result = result.filter(job => {
          if (!job.job_starting_date) return false;

          try {
            const jobDate = new Date(job.job_starting_date);
            jobDate.setHours(0, 0, 0, 0);
            return jobDate >= selectedDate;
          } catch (e) {
            console.error('Error parsing job date:', job.job_starting_date, e);
            return false;
          }
        });
      } catch (e) {
        console.error('Error parsing selected date:', activeFilters.startDate, e);
      }
    }

    setFilteredJobs(result);
  }, [jobs, activeFilters]);

  // Fallback: fetch current candidate profile from canonical endpoint if
  // category/position are missing in cached jobSeekers data.
  useEffect(() => {
    const needsFallback =
      user?.id &&
      (!currentUserProfile ||
        (!currentUserProfile.category &&
          !currentUserProfile.job_category &&
          !currentUserProfile.domestic_worker_category &&
          !currentUserProfile.job_position &&
          !currentUserProfile.position));

    if (!needsFallback) return;

    const fetchCurrentProfile = async () => {
      try {
        const res = await fetch(`${BaseUrl}/api/job-seeker`);
        if (!res.ok) return;
        const data = await res.json();
        const profile = Array.isArray(data)
          ? data.find((seeker) => String(seeker.user_id) === String(user.id))
          : null;
        if (profile) {
          setCurrentUserProfile(profile);
        }
      } catch (err) {
        console.error('Fallback profile fetch failed:', err);
      }
    };

    fetchCurrentProfile();
  }, [user?.id, currentUserProfile]);

  // Get current user profile for display with proper fallbacks
  const currentUserProfileData = currentUserProfile || user;

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="container-fluid joblisting-wrapper py-4">
          <div className="text-center">Loading jobs...</div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="container-fluid joblisting-wrapper py-4">
          <div className="text-center text-danger">Error: {error}</div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />

      {/* Message Modal */}
      <Modal show={showMessageModal} onHide={handleCloseMessageModal} size="xl" centered>
        <Modal.Header closeButton style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
          <Modal.Title style={{ fontSize: '1.25rem', color: '#333', fontWeight: 'bold' }}>
            <i className="bi bi-chat-dots-fill me-2 text-primary"></i>
            Chat with {selectedJob?.emp_name || selectedJob?.name || 'Employer'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, height: '70vh', display: 'flex' }}>
          {/* Split Pane Layout */}
          <div style={{ display: 'flex', width: '100%', height: '100%' }}>

            {/* Left Sidebar - Job Info */}
            <div style={{
              width: isMobile ? '0px' : '300px',
              display: isMobile ? 'none' : 'flex',
              flexDirection: 'column',
              borderRight: '1px solid #dee2e6',
              background: '#fff'
            }}>
              <div style={{ padding: '20px', borderBottom: '1px solid #eee' }}>
                <h6 style={{ fontWeight: 'bold', marginBottom: '15px', color: '#555' }}>Job Details</h6>
                <div className="p-3 rounded" style={{ background: '#f8f9fa', border: '1px solid #eee' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: '5px' }}>{selectedJob?.job_title}</div>
                  <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '10px' }}>{selectedJob?.working_city}, {selectedJob?.country}</div>
                  <Button
                    variant="primary"
                    size="sm"
                    className="w-100"
                    onClick={() => handleJobClick(selectedJob)}
                  >
                    View Job Details
                  </Button>
                </div>
              </div>

              <div style={{ padding: '20px', flex: 1, overflowY: 'auto' }}>
                <h6 style={{ fontWeight: 'bold', marginBottom: '15px', color: '#555' }}>Your Profile</h6>
                <div style={{ fontSize: '0.85rem', color: '#666', lineHeight: '1.6' }}>
                  <div className="mb-2"><strong>Name:</strong> {getDisplayValue(currentUserProfileData.first_name)} {getDisplayValue(currentUserProfileData.last_name)}</div>
                  <div className="mb-2"><strong>Category:</strong> {getProfileCategoryDisplay(currentUserProfileData)}</div>
                  <div className="mb-2"><strong>Position:</strong> {getProfilePositionDisplay(currentUserProfileData)}</div>
                  <div className="mt-3">
                    <a href={`${window.location.origin}/candidateview/${user.id}/${user.first_name}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <i className="bi bi-person-bounding-box me-1"></i> View Full Profile
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Chat Area */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#fcfcfc' }}>

              {/* Chat Header */}
              <div style={{
                padding: '12px 20px',
                background: '#fff',
                borderBottom: '1px solid #dee2e6',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center gap-3">
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      background: '#e9ecef',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      border: '1px solid #dee2e6'
                    }}>
                      {selectedJob?.profile_photo_url ? (
                        <img src={selectedJob.profile_photo_url} alt="Emp" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <i className="bi bi-building text-secondary"></i>
                      )}
                    </div>
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>{selectedJob?.emp_name || selectedJob?.name || 'Employer'}</div>
                      <div style={{ fontSize: '0.75rem', color: '#28a745' }}><i className="bi bi-patch-check-fill me-1"></i> Verified Employer</div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: '36px', height: '36px', border: '1px solid #dee2e6' }}
                      onClick={() => handleContactClick('call')}
                      title="Call Employer"
                    >
                      <i className="bi bi-telephone-fill text-primary"></i>
                    </button>
                    <button
                      className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: '36px', height: '36px', border: '1px solid #dee2e6' }}
                      onClick={() => handleContactClick('whatsapp')}
                      title="WhatsApp Employer"
                    >
                      <i className="bi bi-whatsapp text-success"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Messages Container */}
              <div style={{
                flex: 1,
                overflowY: 'auto',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
              }}>
                {messages.length > 0 ? (
                  messages.map((msg, index) => {
                    const isFromMe = msg.sender === 'job_seeker';
                    return (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: isFromMe ? 'flex-end' : 'flex-start'
                        }}
                      >
                        <div style={{
                          maxWidth: isMobile ? '85%' : '75%',
                          padding: '10px 15px',
                          borderRadius: '12px',
                          background: isFromMe ? '#d1e7dd' : '#fff',
                          border: isFromMe ? '1px solid #badbcc' : '1px solid #dee2e6',
                          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                          position: 'relative'
                        }}>
                          <div style={{ fontSize: '0.9rem', whiteSpace: 'pre-wrap', lineHeight: 1.5, color: '#333' }}>
                            {msg.message}
                          </div>
                          <div style={{
                            fontSize: '0.65rem',
                            color: '#999',
                            marginTop: '5px',
                            textAlign: 'right',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '4px'
                          }}>
                            {new Date(msg.created_at).toLocaleString('en-GB', {
                              day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit'
                            })}
                            {isFromMe ? <i className="bi bi-check2-all text-primary"></i> : <i className="bi bi-reply-fill"></i>}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{
                    textAlign: 'center',
                    color: '#999',
                    marginTop: '50px',
                    fontSize: '0.9rem'
                  }}>
                    <i className="bi bi-chat-left-text" style={{ fontSize: '2rem', display: 'block', marginBottom: '10px' }}></i>
                    No previous messages. Start the conversation!
                  </div>
                )}
              </div>

              {/* Reply Area */}
              <div style={{ padding: '15px 20px', background: '#fff', borderTop: '1px solid #dee2e6' }}>
                <Form.Group controlId="messageContent">
                  <div className="d-flex flex-column gap-2">
                    {(candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub) ? (
                      // Guided Mode
                      canSendMessage && !chatStatus.isLocked ? (
                        // Candidate's turn: show pre-made message (read-only)
                        <div className="p-3 border rounded bg-light" style={{ minHeight: '80px' }}>
                          {chatStatus.stepCount === 4 ? (
                            <div>
                              <p className="mb-2" style={{ fontSize: '0.9rem' }}>
                                My expected salary is <Form.Control
                                  type="text"
                                  size="sm"
                                  style={{ display: 'inline-block', width: '120px' }}
                                  placeholder="e.g. 1000"
                                  value={inputSalary}
                                  maxLength={5}
                                  onChange={(e) => {
                                    const raw = e.target.value.replace(/\D/g, '').slice(0, 5);
                                    setInputSalary(raw);
                                    setMessageContent(getGuidedCandidateMessage(4, getCurrentUserProfile(), selectedJob, raw));
                                  }}
                                />.
                              </p>
                              {!inputSalary.trim() && (
                                <small className="text-danger fw-bold">Expected salary amount is required to send.</small>
                              )}
                            </div>
                          ) : (
                            <p style={{ whiteSpace: 'pre-wrap', margin: 0, fontSize: '0.9rem', color: '#555' }}>
                              {messageContent || 'Preparing your message...'}
                            </p>
                          )}
                        </div>
                      ) : (
                        // Waiting for employer reply OR conversation locked: show active editable textarea
                        <div>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={messageContent}
                            onChange={(e) => setMessageContent(e.target.value)}
                            placeholder={chatStatus.isLocked ? 'Type a message...' : 'Type a message... (waiting for employer reply)'}
                            style={{ resize: 'none', borderRadius: '8px', fontSize: '0.9rem' }}
                          />
                          <small className="text-muted mt-1 d-block">
                            <i className="bi bi-info-circle me-1"></i>
                            Sending a custom message requires a subscription. Wait for employer reply for next guided message.
                          </small>
                        </div>
                      )
                    ) : (
                      // Custom Chat Mode (paid or unlocked)
                      <div className="d-flex gap-2 align-items-end">
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={messageContent}
                          onChange={(e) => setMessageContent(e.target.value)}
                          placeholder="Type your message here..."
                          style={{ resize: 'none', borderRadius: '8px', fontSize: '0.9rem' }}
                        />
                      </div>
                    )}
                  </div>
                </Form.Group>

                {/* Send Button Row */}
                <div className="d-flex justify-content-end mt-3 gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={handleCloseMessageModal}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleSendMessage}
                    className="viewjobs-sendmessagebutton"
                    style={{ paddingLeft: '20px', paddingRight: '20px' }}
                    disabled={
                      !messageContent.trim() ||
                      ((candidateSubPlan === 'free' && !allowFreeCustomChat && !employerHasSub) && chatStatus.stepCount === 4 && canSendMessage && !chatStatus.isLocked && !inputSalary.trim())
                    }
                  >
                    Send Message <i className="bi bi-send-fill ms-1" style={{ fontSize: '0.8rem' }}></i>
                  </Button>
                </div>
              </div>
            </div>

          </div>
        </Modal.Body >
      </Modal >

      {/* Share Modal */}
      < Modal show={showShareModal} onHide={() => setShowShareModal(false)
      } centered >
        <Modal.Header closeButton>
          <Modal.Title>Share Job Opportunity</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-4">Share this job opportunity via:</p>

          <div className="d-flex justify-content-center gap-3 mb-4">
            <Button
              variant="success"
              className="rounded-circle share-btn"
              onClick={() => shareViaWhatsApp(shareContent)}
            >
              <i className="bi bi-whatsapp fs-4"></i>
            </Button>

            <Button
              variant="primary"
              className="rounded-circle share-btn"
              onClick={() => shareViaFacebook(shareUrl)}
            >
              <i className="bi bi-facebook fs-4"></i>
            </Button>

            <Button
              variant="info"
              className="rounded-circle share-btn"
              onClick={() => shareViaTwitter(shareContent)}
            >
              <i className="bi bi-twitter fs-4"></i>
            </Button>

            <Button
              variant="primary"
              className="rounded-circle share-btn"
              style={{ backgroundColor: '#0077b5' }}
              onClick={() => shareViaLinkedIn(shareUrl)}
            >
              <i className="bi bi-linkedin fs-4"></i>
            </Button>

            <Button
              variant="secondary"
              className="rounded-circle share-btn"
              onClick={() => copyToClipboard(shareUrl)}
            >
              <i className="bi bi-link-45deg fs-4"></i>
            </Button>
          </div>

          <Form.Group>
            <Form.Label>Share this text:</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={shareContent}
              readOnly
              onClick={(e) => e.target.select()}
            />
          </Form.Group>
        </Modal.Body>
      </Modal >

      {/* Rest of your JSX remains the same... */}
      < div className="container-fluid joblisting-wrapper py-4" style={{ marginTop: '80px' }}>
        <div className="row">
          {isMobile && (
            <div className="mb-3">
              <button
                className="btn btn-primary w-100"
                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
              >
                <i className={`bi ${showFiltersMobile ? 'bi-chevron-up' : 'bi-chevron-down'} me-2`}></i>
                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
              </button>
            </div>
          )}
          <div className="col-md-3">
            {(showFiltersMobile || !isMobile) && (
              <div className="filters p-3 mb-2 border rounded bg-light">
                {/* Your filter sections remain the same... */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0">Filters</h5>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={resetAllFilters}
                    title="Reset all filters"
                  >
                    <i className="bi bi-arrow-clockwise"></i> Reset
                  </button>
                </div>

                {/* Location Filter */}
                <div className="mb-2 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowLocation(!showLocation)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Job Location</strong>
                    <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showLocation && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {jobLocations.slice(0, showAllLocations ? jobLocations.length : 5).map((loc) => (
                          <div key={loc.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`location-${loc.id}`}
                              checked={activeFilters.location.includes(loc.id)}
                              onChange={() => toggleFilter('location', loc.id)}
                            />
                            <label className="form-check-label d-flex align-items-center" htmlFor={`location-${loc.id}`}>
                              {loc.icon && <img src={loc.icon} alt={loc.name} width="20" height="20" className="me-2" />}
                              {loc.name}
                            </label>
                          </div>
                        ))}
                        {jobLocations.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllLocations(!showAllLocations)}
                          >
                            {showAllLocations ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Rest of your filter sections remain the same... */}
                {/* Job Position Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowPosition(!showPosition)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Job Position</strong>
                    <i className={`bi ${showPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showPosition && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {jobPositions
                          .slice(0, showAllPositions ? jobPositions.length : 5)
                          .map((pos) => (
                            <div key={pos.id} className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="jobPosition"
                                id={`position-${pos.id}`}
                                checked={activeFilters.position === pos.id}
                                onChange={() => toggleRadioFilter('position', pos.id)}
                              />
                              <label
                                className="form-check-label d-flex align-items-center"
                                htmlFor={`position-${pos.id}`}
                              >
                                {pos.icon && (
                                  <img
                                    src={pos.icon}
                                    alt={pos.name}
                                    width="20"
                                    height="20"
                                    className="me-2"
                                  />
                                )}
                                {pos.name}
                              </label>
                            </div>
                          ))}

                        {jobPositions.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllPositions(!showAllPositions)}
                          >
                            {showAllPositions ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Start Date Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowStartDate(!showStartDate)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Start Date</strong>
                    <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showStartDate && (
                    <div className="filter-content">
                      <div className="p-2 bg-white rounded border">
                        <input
                          type="date"
                          className="form-control"
                          value={activeFilters.startDate}
                          onChange={(e) => setActiveFilters({ ...activeFilters, startDate: e.target.value })}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Job Type Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowJobType(!showJobType)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Job Type</strong>
                    <i className={`bi ${showJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showJobType && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {jobTypes.slice(0, showAllJobTypes ? jobTypes.length : 5).map((type) => (
                          <div key={type.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="jobType"
                              id={`type-${type.id}`}
                              checked={activeFilters.jobType === type.id}
                              onChange={() => toggleRadioFilter('jobType', type.id)}
                            />
                            <label className="form-check-label d-flex align-items-center" htmlFor={`type-${type.id}`}>
                              {type.icon && <img src={type.icon} alt={type.name} width="20" height="20" className="me-2" />}
                              {type.name}
                            </label>
                          </div>
                        ))}
                        {jobTypes.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllJobTypes(!showAllJobTypes)}
                          >
                            {showAllJobTypes ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Contract Status Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowContractStatus(!showContractStatus)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Contract Status</strong>
                    <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showContractStatus && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {contractStatuses.slice(0, showAllContractStatuses ? contractStatuses.length : 5).map((status) => (
                          <div key={status.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`status-${status.id}`}
                              checked={activeFilters.contractStatus.includes(status.id)}
                              onChange={() => toggleFilter('contractStatus', status.id)}
                            />
                            <label className="form-check-label" htmlFor={`status-${status.id}`}>
                              {status.name}
                            </label>
                          </div>
                        ))}
                        {contractStatuses.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllContractStatuses(!showAllContractStatuses)}
                          >
                            {showAllContractStatuses ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Post By Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowPostBy(!showPostBy)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Post By</strong>
                    <i className={`bi ${showPostBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showPostBy && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {postByOptions.map((option) => (
                          <div key={option.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="postBy"
                              id={`postby-${option.id}`}
                              checked={activeFilters.postBy === option.id}
                              onChange={() => toggleRadioFilter('postBy', option.id)}
                            />
                            <label className="form-check-label" htmlFor={`postby-${option.id}`}>
                              {option.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Language Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowLanguage(!showLanguage)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Language</strong>
                    <i className={`bi ${showLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showLanguage && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {languages.slice(0, showAllLanguages ? languages.length : 5).map((lang) => (
                          <div key={lang.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`lang-${lang.id}`}
                              checked={activeFilters.language.includes(lang.id)}
                              onChange={() => toggleFilter('language', lang.id)}
                            />
                            <label className="form-check-label" htmlFor={`lang-${lang.id}`}>
                              {lang.name}
                            </label>
                          </div>
                        ))}
                        {languages.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllLanguages(!showAllLanguages)}
                          >
                            {showAllLanguages ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Main Skills Filter */}
                <div className="mb-4 filter-section">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={() => setShowSkills(!showSkills)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Main Skills</strong>
                    <i className={`bi ${showSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                  </div>
                  {showSkills && (
                    <div className="filter-content">
                      <div className="d-flex flex-column gap-2">
                        {mainSkills.slice(0, showAllSkills ? mainSkills.length : 5).map((skill) => (
                          <div key={skill.id} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`skill-${skill.id}`}
                              checked={activeFilters.skills.includes(skill.id)}
                              onChange={() => toggleFilter('skills', skill.id)}
                            />
                            <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                              {skill.name}
                            </label>
                          </div>
                        ))}
                        {mainSkills.length > 5 && (
                          <button
                            className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                            onClick={() => setShowAllSkills(!showAllSkills)}
                          >
                            {showAllSkills ? 'Show Less' : 'Show More'}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Job Listings */}
          <div className="col-md-9">
            {filteredJobs.length === 0 ? (
              <div className="text-center no-jobs-message">No jobs match your filters</div>
            ) : (
              <div className="row">
                {filteredJobs.map((job) => {
                  const badge = getSubscriptionBadge(job);
                  const employee = getEmployeeDetails(job);

                  return (
                    <div key={job.id} className="col-md-12 mb-4">
                      <div
                        className="jobcard-wrapper-jobseeker-viewjobs d-flex p-3 shadow-sm rounded"
                        onClick={() => handleJobClick(job)}
                        style={{ cursor: 'pointer' }}
                      >
                        {/* Image Section */}
                        {/* Image Section */}
                        <div className="jobcard-image text-center" style={{ width: '18%', flexShrink: 0 }}>
                          <div className="viewjob-avatar-wrap mb-2">
                            <img
                              src={job.profile_photo_url || job.dummy_profile_image}
                              alt={job.job_title}
                              className="img-fluid jobcard-avatar-eviewjobs viewjob-image"
                              onError={(e) => {
                                // If image fails to load, use dummy profile image
                                e.target.src = job.dummy_profile_image || dummyProfileImages[0];
                              }}
                            />
                          </div>

                          {/* Stars and Employer text side by side */}
                          <div className="d-flex justify-content-center align-items-center mb-1">
                            {/* Stars on left side */}
                            <div className="me-2">
                              {hasGoldSubscription(job) && (
                                <span className="star-icon" title="Gold Subscription Employer">
                                  <i className="bi bi-star-fill text-warning"></i>
                                </span>
                              )}
                              {hasSilverSubscription(job) && (
                                <span className="star-icon" title="Silver Subscription Employer">
                                  <i className="bi bi-star-fill text-secondary"></i>
                                </span>
                              )}
                            </div>

                            {/* Employer text on right side */}
                            <div className="jobcard-label-text mb-0">
                              {job.posted_by?.toLowerCase().includes('direct') ? 'Employer' : 'Agency'}
                            </div>
                          </div>
                        </div>

                        {/* Content Section */}
                        <div className="jobcard-content ms-3" style={{ width: '82%' }}>
                          <div className="d-flex mb-2">
                            <h5 className="jobcard-title mb-0 me-2">
                              {job.job_title}
                            </h5>
                            {/* Gold and Silver Stars - Properly aligned in same line */}
                            <div className="d-flex align-items-center silverandgoldstar">
                              {hasGoldSubscription(job) && (
                                <span className="me-2" title="Gold Subscription Employer">
                                  {/* <i className="bi bi-star-fill text-warning"></i> */}
                                </span>
                              )}
                              {hasSilverSubscription(job) && (
                                <span title="Silver Subscription Employer">
                                  {/* <i className="bi bi-star-fill text-secondary"></i> */}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* Display Employee Details if available */}
                          {employee && (
                            <div className="employee-preview mb-2 p-2 bg-light rounded small">
                              <strong>Posted By:</strong> {getDisplayValue(employee.first_name)} {getDisplayValue(employee.last_name)} |
                              <strong> Age:</strong> {getDisplayValue(employee.age)} |
                              <strong> Exp:</strong> {getDisplayValue(employee.total_work_experience)} |
                              <strong> Nationality:</strong> {getDisplayValue(employee.nationality)}
                            </div>
                          )}

                          <div className="jobcard-family text-muted mb-1">
                            {(() => {
                              const parts = [];

                              // Add adults and kids part if either exists
                              if (job.adults && job.children) {
                                parts.push(`${job.adults} adults + ${job.children} kids`);
                              } else if (job.adults) {
                                parts.push(`${job.adults} adults`);
                              } else if (job.children) {
                                parts.push(`${job.children} kids`);
                              }

                              // Add country if it exists
                              if (job.country && job.country !== 'N/A' && job.country !== 'null' && job.country !== 'undefined') {
                                parts.push(job.country);
                              }

                              // Join with separator if there are multiple parts
                              return parts.length > 0 ? parts.join(' | ') : null;
                            })()}
                          </div>
                          <div className="jobcard-location text-muted mb-1">
                            <i className="bi bi-geo-alt-fill me-1"></i>
                            {job.working_city || 'N/A'}, {job.state_or_province || 'N/A'}
                          </div>
                          <div className="viewjobs-jobcard-description text-muted mb-4">
                            {job.job_description || 'No description available'}
                          </div>
                          <div className="d-flex flex-wrap align-items-center gap-1 small mt-1">
                            <div className="text-muted">
                              <i className="bi bi-person-fill me-1"></i>
                              {job.domestic_worker_category || 'N/A'} | {job.job_type || 'N/A'}
                            </div>
                            <div className="text-muted me-3">
                              <i className="bi bi-calendar-event me-1"></i>
                              <strong>Joining Date:</strong>&nbsp;
                              {
                                job.job_starting_date &&
                                  (job.job_starting_date.toString().toLowerCase().includes('immediately') ||
                                    job.job_starting_date.toString().toLowerCase().includes('asap') ||
                                    job.job_starting_date.toString().toLowerCase().includes('soon') ||
                                    job.job_starting_date.toString().toLowerCase().includes('urgent'))
                                  ? job.job_starting_date
                                  : formatDate(job.job_starting_date)
                              }
                            </div>


                            {/* Action Buttons - Only for Gold subscribers */}
                            {/* Action Buttons */}
                            <div className="d-flex gap-1 ms-0">
                              {/* Message Button - Show for ALL employers */}
                              <Button
                                variant=""
                                className="message-jobseeker employeejobs-messagebutton"
                                onClick={(e) => handleMessageClick(job, e)}
                              >
                                <i className="bi bi-chat-dots me-1 d-none d-md-inline"></i>
                                <span>Message</span>
                              </Button>

                              {/* Call Button - Only for Gold subscribers */}
                              {hasGoldSubscription(job) && (
                                <Button
                                  variant="secondary"
                                  className="call-btn-jobseeker employeejobs-callbutton"
                                  onClick={(e) => handleCallClick(job, e)}
                                >
                                  <i className="bi bi-telephone-fill me-1 d-none d-md-inline"></i>
                                  <span>Call</span>
                                </Button>
                              )}

                              {/* WhatsApp Button - Only for Gold subscribers */}
                              {hasGoldSubscription(job) && (
                                <Button
                                  variant="success"
                                  className="whatsapp-btn-jobseeker employeejobs-whatsappbutton"
                                  onClick={(e) => handleWhatsAppClick(job, e)}
                                >
                                  <i className="bi bi-whatsapp me-1 d-none d-md-inline"></i>
                                  <span>WhatsApp</span>
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div >
      <Footer />
    </>
  );
}

export default ViewJobs;




